import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ExportBoundaryContainer, type ExportBoundaryContainerProps,
} from './exportBoundary.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportBoundaryData: ExportBoundaryContainerProps;
  }
}
modalRenderer.register('ExportBoundaryData', ExportBoundaryContainer);
